module.exports = __webpack_public_path__ + "static/media/pickleball.545aa301.jpg";